// import api from "./api";

// const shopService = {
//   // DEALER: Get own shops
//   getShops: async () => {
//     const response = await api.get("/dealer/shops");
//     return response.data;
//   },

//   // DEALER: Create shop and shop-owner account
//   createShop: async (shopData) => {
//     const response = await api.post("/dealer/create-shop", {
//       full_name: String(shopData.full_name || "").trim(),
//       username: String(shopData.username || "").trim(),
//       password: String(shopData.password || ""),
//       mobile: String(shopData.mobile || "").trim(),
//       shop_name: String(shopData.shop_name || "").trim(),
//       address: String(shopData.address || "").trim(),
//     });

//     return response.data;
//   },

//   // DEALER: Block / unblock own shop
//   updateShopStatus: async (shopIdOrData, statusParam, shopOwnerIdParam) => {
//     let payload = {};
//     if (typeof shopIdOrData === "object" && shopIdOrData !== null) {
//       const sId = shopIdOrData.shop_id || shopIdOrData.id;
//       const oId = shopIdOrData.shop_owner_id || shopIdOrData.owner_id || sId;
//       payload = {
//         shop_id: Number(sId),
//         shop_owner_id: Number(oId),
//         owner_id: Number(oId),
//         status: String(shopIdOrData.status).toUpperCase(),
//       };
//     } else {
//       const sId = shopIdOrData;
//       const status = statusParam;
//       const oId = shopOwnerIdParam || sId;
//       payload = {
//         shop_id: Number(sId),
//         shop_owner_id: Number(oId),
//         owner_id: Number(oId),
//         status: String(status).toUpperCase(),
//       };
//     }

//     const response = await api.patch("/dealer/shop-status", payload);
//     return response.data;
//   },

//   // DEALER: Transfer coins to shop owner
//   transferToShop: async (shopOwnerId, amount) => {
//     const response = await api.post("/dealer/transfer-to-shop", {
//       shop_owner_id: Number(shopOwnerId),
//       amount: Number(amount),
//     });

//     return response.data;
//   },
// };

// export default shopService;





import api from "./api";

const shopService = {
  // ============================================================
  // DEALER: GET OWN SHOPS
  // ============================================================

  getShops: async () => {
    const response = await api.get(
      "/dealer/shops"
    );

    return response.data;
  },


  // ============================================================
  // DEALER: CREATE SHOP
  // ============================================================

  createShop: async (shopData) => {
    const response = await api.post(
      "/dealer/create-shop",
      {
        full_name: String(
          shopData.full_name || ""
        ).trim(),

        username: String(
          shopData.username || ""
        ).trim(),

        password: String(
          shopData.password || ""
        ),

        mobile: String(
          shopData.mobile || ""
        ).trim(),

        shop_name: String(
          shopData.shop_name || ""
        ).trim(),

        address: String(
          shopData.address || ""
        ).trim(),
      }
    );

    return response.data;
  },


  // ============================================================
  // DEALER: BLOCK / UNBLOCK OWN SHOP
  // ============================================================

  updateShopStatus: async (
    shopIdOrData,
    statusParam,
    shopOwnerIdParam
  ) => {
    let payload = {};

    if (
      typeof shopIdOrData === "object" &&
      shopIdOrData !== null
    ) {
      const sId =
        shopIdOrData.shop_id ||
        shopIdOrData.id;

      const oId =
        shopIdOrData.shop_owner_id ||
        shopIdOrData.owner_id ||
        sId;

      payload = {
        shop_id: Number(sId),

        shop_owner_id:
          Number(oId),

        owner_id:
          Number(oId),

        status: String(
          shopIdOrData.status
        ).toUpperCase(),
      };
    } else {
      const sId =
        shopIdOrData;

      const status =
        statusParam;

      const oId =
        shopOwnerIdParam ||
        sId;

      payload = {
        shop_id:
          Number(sId),

        shop_owner_id:
          Number(oId),

        owner_id:
          Number(oId),

        status: String(
          status
        ).toUpperCase(),
      };
    }

    const response = await api.patch(
      "/dealer/shop-status",
      payload
    );

    return response.data;
  },


  // ============================================================
  // DEALER: TRANSFER CREDITS TO SHOP
  // ============================================================

  transferToShop: async (
    shopOwnerId,
    amount
  ) => {
    const response = await api.post(
      "/dealer/transfer-to-shop",
      {
        shop_owner_id:
          Number(shopOwnerId),

        amount:
          Number(amount),
      }
    );

    return response.data;
  },

  // ============================================================
  // DEALER: DELETE SHOP
  // ============================================================

  deleteShop: async (shopId) => {
    const response = await api.delete(
      `/dealer/shops/${shopId}`
    );

    return response.data;
  },
    // ============================================================
  // SHOP: GET COMPUTERS
  // ============================================================

  getComputers: async () => {
    const response = await api.get(
      "/shop/computers"
    );

    return response.data;
  },


  // ============================================================
  // SHOP: CREATE COMPUTER
  // ============================================================

  createComputer: async (computerData) => {
    const response = await api.post(
      "/shop/computers",
      {
        computer_code: String(
          computerData.computer_code || ""
        )
          .trim()
          .toUpperCase(),

        password: String(
          computerData.password || ""
        ),
      }
    );

    return response.data;
  },


  // ============================================================
  // SHOP: CHANGE COMPUTER PASSWORD
  // ============================================================

  changeComputerPassword: async (
    computerId,
    password
  ) => {
    const response = await api.patch(
      `/shop/computers/${Number(
        computerId
      )}/password`,
      {
        password: String(password || ""),
      }
    );

    return response.data;
  },


  // ============================================================
  // SHOP: ACTIVATE / BLOCK COMPUTER
  // ============================================================

  updateComputerStatus: async (
    computerId,
    status
  ) => {
    const response = await api.patch(
      `/shop/computers/${Number(
        computerId
      )}/status`,
      {
        status: String(status || "")
          .trim()
          .toUpperCase(),
      }
    );

    return response.data;
  },

  // ============================================================
  // SHOP: TRANSFER COINS TO COMPUTER
  // ============================================================

  transferToComputer: async (
    computerId,
    amount
  ) => {
    const response = await api.post(
      "/shop/transfer-to-computer",
      {
        computer_id: Number(computerId),
        amount: Number(amount),
      }
    );

    return response.data;
  },

  // ============================================================
  // SHOP: TAKE / WITHDRAW COINS FROM COMPUTER (CUT COINS)
  // ============================================================

  takeFromComputer: async (
    computerId,
    amount
  ) => {
    const response = await api.post("/shop/take-from-computer", {
      computer_id: Number(computerId),
      amount: Number(amount),
    });

    return response.data;
  },

  // ============================================================
  // SHOP: RESET COMPUTER DEVICE LOCK
  // ============================================================

  resetComputerDeviceBinding: async (computerId) => {
    const response = await api.patch(
      `/shop/computers/${Number(computerId)}/reset-device`
    );

    return response.data;
  },

  // ============================================================
  // SHOP: DELETE COMPUTER
  // ============================================================

  deleteComputer: async (computerId) => {
    const response = await api.delete(
      `/shop/computers/${Number(computerId)}`
    );

    return response.data;
  },
};

export default shopService;